// import React from "react";
// import logo from "../assets/logo.png"
// import {Link} from "react-router-dom"
// import { socialLinks, WhatsAppIcon } from "../utils/Quick Links/Links";
// import { ChevronRight, Mail, MapPin, Phone } from "lucide-react";

// const Footer = () => {
//   const nav_links = [
//     { name: "About", link: "/about-public-health-conclave/" },
//     { name: "Executive Panel", link: "/executive-panel-members/" },
//     { name: "Tracks", link: "/public-health-conference-tracks/" },
//     { name: "Orators", link: "/world-public-health-summit-orators" },
//     { name: "Schedule", link: "/public-health-event-schedule" },
//     // { name: "Venue", link: "/venue" },
//     { name: "Event Partners", link: "/event_partners" },
//     { name: "Contact", link: "/Contact" },
//   ];

//   return (
//     <div className="flex py-6 rounded-t-3xl flex-col md:flex-row md:justify-between bg-black px-6 md:px-12 py-2 text-white gap-8 md:gap-0 items-stretch">
      
//       {/* Grid 1 */}
//       <div className="w-full md:w-1/4 gap-4 flex flex-col items-center text-center">
//         {/* <h1 className="text-slate-100 text-3xl">Mediclave</h1> */}
//         {/* <h1 className="text-slate-100 text-3xl">OralMed</h1> */}
//         <div className="bg-white pt-8 mt-4 p-4 rounded-full">
//           <img src={logo} alt="Public Health Logo" className="h-32 md:h-[160px] md:w-38 object-cover rounded-lg" loading="lazy" />
//         </div>
//         <p className="text-slate-200 text-sm px-4 md:px-8">
//           Innovative Nursing Practices: Transforming Public Health through Technology.
//         </p>
//       </div>

//       {/* Grid 2 */}
//       <div className="w-full ml-[5%] md:w-1/4 flex flex-col items-start md:text-left">
//         <h1 className="text-one font-semibold text-3xl border-b border-slate-800">
//           Quick Links
//         </h1>
//         <div className="flex flex-col mt-4 gap-1">
//           {nav_links.map((item, idx) => (
//             <div key={idx} className="flex flex-row gap-1 justify-center md:justify-start items-center">
//               <ChevronRight />
//               <Link to={item.link}>
//                 {item.name}
//               </Link>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Grid 3 */}
//       <div className="w-full md:w-1/4 flex flex-col items-center md:items-start text-center md:text-left">
//         <h1 className="text-one font-semibold text-3xl border-b border-slate-800 w-auto md:w-[16vw]">
//           Social Media
//         </h1>
//         {socialLinks.map(({ id, name, url, icon }) => (
//           <div key={id} className="flex flex-row items-center justify-center md:justify-start">
//             <Link
//               to={url}
//               target="_blank"
//               rel="noopener noreferrer"
//               title={name}
//               className="text-one p-2 rounded-full bg-black text-md cursor-pointer flex flex-row items-center gap-2"
//             >
//               {icon}<p className="text-white">{name}</p>
//             </Link>
//           </div>
//         ))}
//       </div>

//       {/* Grid 4 */}
//       <div className="w-full md:w-1/4 flex flex-col gap-4 items-center md:items-start text-center md:text-left">
//         <h1 className="text-one font-semibold text-3xl border-b border-slate-800">
//           Get In Touch
//         </h1>
//         <div className="flex flex-col gap-4 text-slate-300">
//           <div className="flex flex-row gap-2 items-center justify-center md:justify-start">
//             <Phone size="18" />
//             <p>+1757 656 7778</p>
//           </div>
//           <div className="flex flex-row gap-2 items-center justify-center md:justify-start">
//             <WhatsAppIcon className="h-5 w-5 fill-slate-300"/>
//             <p>+1715 990 5583</p>
//           </div>
//           <div className="flex flex-row gap-2 items-center justify-center md:justify-start">
//             <Mail size="18" />
//             <p>hello@helixconferences.com</p>
//           </div>
//           <div className="flex flex-row gap-2 items-start md:justify-start px-4 md:px-0">
//             <MapPin size="44" />
//             <p>
//               Helix Conferences LLC, 45573 Shepard Drive, Suit#101,
//               Sterling, Virginia-20164, USA
//             </p>
//           </div>
//         </div>
//         <div className="flex flex-col">
//           <Link to="https://helixconferences.com/register.php?type=webinar" target="blank" className="bg-one px-12 py-2 rounded-full mt-1">
//             Register
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Footer;



// import React from "react";
// import logo from "../assets/logo.png";
// import { Link } from "react-router-dom";
// import { socialLinks, WhatsAppIcon } from "../utils/Quick Links/Links";
// import { ChevronRight, Mail, MapPin, Phone } from "lucide-react";
// import VisitCounter from "./ui/visitCounter";

// const Footer = () => {
//   const nav_links = [
//     { name: "About", link: "/about-public-health-conclave/" },
//     { name: "Executive Panel", link: "/executive-panel-members/" },
//     { name: "Tracks", link: "/public-health-conference-tracks/" },
//     { name: "Orators", link: "/world-public-health-summit-orators" },
//     { name: "Schedule", link: "/public-health-event-schedule" },
//     { name: "Event Partners", link: "/event_partners" },
//     { name: "Contact", link: "/Contact" },
//   ];

//   return (
//     <div className="flex flex-col rounded-t-2xl md:flex-row md:justify-between bg-black px-4 sm:px-6 md:px-12 py-4 md:py-8 text-white gap-10 md:gap-6 items-start md:items-stretch">
//       {/* Grid 1 */}
//       <div className="w-full md:w-1/4 flex flex-col items-center md:items-start text-center md:text-left gap-4">
//         <div className="bg-white pt-10 p-4 rounded-full">
//           <img
//             src={logo}
//             alt="Public Health Logo"
//             className="h-32 sm:h-32 md:h-[180px] object-cover rounded-full"
//             loading="lazy"
//           />
//         </div>
//         <p className="text-slate-200 text-sm px-4 md:px-0 max-w-xs">
//           Innovative Nursing Practices: Transforming Public Health through Technology.
//         </p>
//       </div>

//       {/* Grid 2 */}
//       <div className="w-full md:w-1/4 flex flex-col items-center md:items-start text-center md:text-left">
//         <h1 className="text-one font-semibold text-2xl sm:text-3xl border-b border-slate-800 w-full pb-1">
//           Quick Links
//         </h1>
//         <div className="flex flex-col mt-4 gap-4 w-full">
//           {nav_links.map((item, idx) => (
//             <div key={idx} className="flex flex-row gap-1 justify-center md:justify-start items-center text-sm sm:text-base">
//               <ChevronRight size={16} />
//               <Link to={item.link}>{item.name}</Link>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Grid 3 */}
//       <div className="w-full md:w-1/4 flex flex-col items-center md:items-start text-center md:text-left">
//         <h1 className="text-one font-semibold text-2xl sm:text-3xl border-b border-slate-800 w-full pb-1">
//           Social Media
//         </h1>
//         <div className="flex flex-col mt-2 gap-2 w-full">
//           {socialLinks.map(({ id, name, url, icon }) => (
//             <div key={id} className="flex flex-row items-center justify-center md:justify-start">
//               <Link
//                 to={url}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 title={name}
//                 className="text-one p-2 rounded-full text-md cursor-pointer flex flex-row items-center gap-2"
//               >
//                 {icon}<p className="text-white">{name}</p>
//               </Link>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Grid 4 */}
//       <div className="w-full md:w-1/4 flex flex-col gap-4 items-center md:items-start text-center md:text-left">
//         <h1 className="text-one font-semibold text-2xl sm:text-3xl border-b border-slate-800 w-full pb-1">
//           Get In Touch
//         </h1>
//         <div className="flex flex-col gap-6 text-slate-300 w-full">
//           <div className="flex flex-row gap-2 items-center justify-center md:justify-start text-sm sm:text-base">
//             <Phone size="18" />
//             <p>+1757 656 7778</p>
//           </div>
//           <div className="flex flex-row gap-2 items-center justify-center md:justify-start text-sm sm:text-base">
//             <WhatsAppIcon className="h-5 w-5 fill-slate-300" />
//             <p>+1715 990 5583</p>
//           </div>
//           <div className="flex flex-row gap-2 items-center justify-center md:justify-start text-sm sm:text-base">
//             <Mail size="18" />
//             <p>hello@helixconferences.com</p>
//           </div>
//           <div className="flex flex-row gap-2 items-start justify-center md:justify-start px-4 md:px-0 text-sm sm:text-base">
//             <MapPin size="44" />
//             <p className="text-left">
//               Helix Conferences LLC, 45573 Shepard Drive, Suit#101,<br />
//               Sterling, Virginia-20164, USA
//             </p>
//           </div>
//         </div>
//         <div className="flex flex-col">
//           <Link to="https://helixconferences.com/register.php?type=webinar" target="blank" className="bg-one px-8 sm:px-12 py-2 rounded-full mt-1 text-sm sm:text-base">
//             Register
//           </Link>
//       <VisitCounter/>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Footer;


// import React from "react";
// import logo from "../assets/logo.png";
// import { Link } from "react-router-dom";
// import { socialLinks, WhatsAppIcon } from "../utils/Quick Links/Links";
// import { ChevronRight, Mail, MapPin, Phone } from "lucide-react";
// import VisitCounter from "./ui/visitCounter"; // Ensure this path is correct

// const Footer = () => {
//   const nav_links = [
//     { name: "About", link: "/about-public-health-conclave/" },
//     { name: "Executive Panel", link: "/executive-panel-members/" },
//     { name: "Tracks", link: "/public-health-conference-tracks/" },
//     { name: "Orators", link: "/world-public-health-summit-orators" },
//     { name: "Schedule", link: "/public-health-event-schedule" },
//     { name: "Event Partners", link: "/event_partners" },
//     { name: "Contact", link: "/Contact" },
//   ];

//   return (
//     <div className="flex flex-col rounded-t-2xl md:flex-row md:justify-between bg-black px-4 sm:px-6 md:px-12 py-4 md:py-8 text-white gap-10 md:gap-6 items-start md:items-stretch">
//       {/* Grid 1 */}
//       <div className="w-full md:w-1/4 flex flex-col items-center md:items-start text-center md:text-left gap-4">
//         <div className="bg-white pt-10 p-4 rounded-full">
//           <img
//             src={logo}
//             alt="Public Health Logo"
//             className="h-32 sm:h-32 md:h-[180px] object-cover rounded-full"
//             loading="lazy"
//           />
//         </div>
//         <p className="text-slate-200 text-sm px-4 md:px-0 max-w-xs">
//           Innovative Nursing Practices: Transforming Public Health through Technology.
//         </p>
//       </div>

//       {/* Grid 2 */}
//       <div className="w-full md:w-1/4 flex flex-col items-center md:items-start text-center md:text-left">
//         <h1 className="text-one font-semibold text-2xl sm:text-3xl border-b border-slate-800 w-full pb-1">
//           Quick Links
//         </h1>
//         <div className="flex flex-col mt-4 gap-4 w-full">
//           {nav_links.map((item, idx) => (
//             <div key={idx} className="flex flex-row gap-1 justify-center md:justify-start items-center text-sm sm:text-base">
//               <ChevronRight size={16} />
//               <Link to={item.link}>{item.name}</Link>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Grid 3 */}
//       <div className="w-full md:w-1/4 flex flex-col items-center md:items-start text-center md:text-left">
//         <h1 className="text-one font-semibold text-2xl sm:text-3xl border-b border-slate-800 w-full pb-1">
//           Social Media
//         </h1>
//         <div className="flex flex-col mt-2 gap-2 w-full">
//           {socialLinks.map(({ id, name, url, icon }) => (
//             <div key={id} className="flex flex-row items-center justify-center md:justify-start">
//               <Link
//                 to={url}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 title={name}
//                 className="text-one p-2 rounded-full text-md cursor-pointer flex flex-row items-center gap-2"
//               >
//                 {icon}<p className="text-white">{name}</p>
//               </Link>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Grid 4 */}
//       <div className="w-full md:w-1/4 flex flex-col gap-4 items-center md:items-start text-center md:text-left">
//         <h1 className="text-one font-semibold text-2xl sm:text-3xl border-b border-slate-800 w-full pb-1">
//           Get In Touch
//         </h1>
//         <div className="flex flex-col gap-6 text-slate-300 w-full">
//           <div className="flex flex-row gap-2 items-center justify-center md:justify-start text-sm sm:text-base">
//             <Phone size="18" />
//             <p>+1757 656 7778</p>
//           </div>
//           <div className="flex flex-row gap-2 items-center justify-center md:justify-start text-sm sm:text-base">
//             <WhatsAppIcon className="h-5 w-5 fill-slate-300" />
//             <p>+1715 990 5583</p>
//           </div>
//           <div className="flex flex-row gap-2 items-center justify-center md:justify-start text-sm sm:text-base">
//             <Mail size="18" />
//             <p>hello@helixconferences.com</p>
//           </div>
//           <div className="flex flex-row gap-2 items-start justify-center md:justify-start px-4 md:px-0 text-sm sm:text-base">
//             <MapPin size="44" />
//             <p className="text-left">
//               Helix Conferences LLC, 45573 Shepard Drive, Suit#101,<br />
//               Sterling, Virginia-20164, USA
//             </p>
//           </div>
//         </div>
//         <div className="flex flex-row items-center gap-4"> {/* Changed to flex-row and added gap */}
//           <VisitCounter  /> {/* VisitCounter is now placed here */}
//           <Link to="https://helixconferences.com/register.php?type=webinar" target="blank" className="bg-one px-8  sm:px-12 py-2 rounded-full mt-1 text-sm ml-10 sm:text-base">
//             Register
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Footer;


import React from "react";
import logo from "../assets/logo.png";
import { Link } from "react-router-dom";
import { socialLinks, WhatsAppIcon } from "../utils/Quick Links/Links";
import { ChevronRight, Mail, MapPin, Phone } from "lucide-react";
import VisitCounter from "./ui/visitCounter"; // Ensure this path is correct

const Footer = () => {
  const nav_links = [
    { name: "About", link: "/about-public-health-conclave/" },
    { name: "Executive Panel", link: "/executive-panel-members/" },
    { name: "Tracks", link: "/public-health-conference-tracks/" },
    { name: "Orators", link: "/world-public-health-summit-orators" },
    { name: "Schedule", link: "/public-health-event-schedule" },
    { name: "Venue", link: "/venue" },
    { name: "Event Partners", link: "/event_partners" },
    { name: "Contact", link: "/Contact" },
  ];

  return (
    <div className="flex flex-col rounded-t-2xl md:flex-row md:justify-between bg-black px-4 sm:px-6 md:px-12 py-4 md:py-8 text-white gap-10 md:gap-6 items-start md:items-stretch">
      {/* Grid 1 */}
      <div className="w-full md:w-1/4 flex flex-col items-center md:items-start text-center md:text-left gap-4">
        <div className="bg-white pt-10 p-4 rounded-full">
          <img
            src={logo}
            alt="Public Health Logo"
            className="h-32 sm:h-32 md:h-[180px] object-cover rounded-full"
            loading="lazy"
          />
        </div>
        <p className="text-slate-200 text-sm px-4 md:px-0 max-w-xs">
          Innovative Nursing Practices: Transforming Public Health through Technology.
        </p>
      </div>

      {/* Grid 2 */}
      <div className="w-full md:w-1/4 flex flex-col items-center md:items-start text-center md:text-left">
        <h1 className="text-one font-semibold text-2xl sm:text-3xl border-b border-slate-800 w-full pb-1">
          Quick Links
        </h1>
        <div className="flex flex-col mt-4 gap-3 w-full">
          {nav_links.map((item, idx) => (
            <div key={idx} className="flex flex-row gap-1 justify-center md:justify-start items-center text-sm sm:text-base">
              <ChevronRight size={16} />
              <Link to={item.link}>{item.name}</Link>
            </div>
          ))}
        </div>
      </div>

      {/* Grid 3 */}
      <div className="w-full md:w-1/4 flex flex-col items-center md:items-start text-center md:text-left">
        <h1 className="text-one font-semibold text-2xl sm:text-3xl border-b border-slate-800 w-full pb-1">
          Social Media
        </h1>
        <div className="flex flex-col mt-4 gap-2 w-full">
          {socialLinks.map(({ id, name, url, icon }) => (
            <div key={id} className="flex flex-row items-center justify-center md:justify-start">
              <Link
                to={url}
                target="_blank"
                rel="noopener noreferrer"
                title={name}
                className="text-one p-2 rounded-full text-md cursor-pointer flex flex-row items-center gap-2"
              >
                {icon}<p className="text-white">{name}</p>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Grid 4 */}
      <div className="w-full md:w-1/4 flex flex-col gap-4 items-center md:items-start text-center md:text-left">
        <h1 className="text-one font-semibold text-2xl sm:text-3xl border-b border-slate-800 w-full pb-1">
          Get In Touch
        </h1>
        <div className="flex flex-col gap-6 text-slate-300 w-full">
          <div className="flex flex-row gap-2 items-center justify-center md:justify-start text-sm sm:text-base">
            <Phone size="18" />
            <p>+1757 656 7778</p>
          </div>
          <div className="flex flex-row gap-2 items-center justify-center md:justify-start text-sm sm:text-base">
            <WhatsAppIcon className="h-5 w-5 fill-slate-300" />
            <p>+1715 990 5583</p>
          </div>
          <div className="flex flex-row gap-2 items-center justify-center md:justify-start text-sm sm:text-base">
            <Mail size="18" />
            <p>hello@helixconferences.com</p>
          </div>
          <div className="flex flex-row gap-2 items-start justify-center md:justify-start px-4 md:px-0 text-sm sm:text-base">
            <MapPin size="44" />
            <p className="text-left">
              Helix Conferences LLC, 45573 Shepard Drive, Suit#101,<br />
              Sterling, Virginia-20164, USA
            </p>
          </div>
        </div>
        <div className="flex flex-row items-center gap-4"> {/* This parent ensures they are on the same line and vertically centered */}
          <VisitCounter /> {/* VisitCounter is now placed here */}
          {/* Removed mt-1 and ml-10. Let gap-4 on the parent control spacing */}
          <Link to="https://helixconferences.com/register.php?type=conference" target="blank" className="bg-one px-8 sm:px-12 py-2 rounded-full text-sm sm:text-base">
            Register
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;